var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#h';
                    var viewUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#view-h';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '137.718 -1.001 366.563 644',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };